<template>
  <card v-loading="loading">
    <div slot="header" class="row align-items-center">
      <div class="col">
        <h6 class="text-uppercase text-muted ls-1 mb-1">Dados</h6>
        <h5 class="h3 mb-0">Curva ABC</h5>
      </div>
    </div>

    <bar-chart
      v-if="mappedData"
      :height="350"
      :chart-data="bigBarChart.chartData"
    />
  </card>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue';
import axios from "@/backend/axios/index.js";
import BarChart from "@/components/Charts/BarChart";


const loading = ref(false);
const mappedData = ref(false)

const bigBarChart = ref({
  chartData: {
    datasets: [
      {
        label: "A",
        data: [0, 0, 0],
        backgroundColor: "#2dce89",
      },
      {
        label: "B",
        data: [0, 0, 0],
        backgroundColor: "blue",
      },
      {
        label: "C",
        data: [0, 0, 0],
        backgroundColor: "green",
      },
      {
        label: "D",
        data: [0, 0, 0],
        backgroundColor: "yellow",
      },
      {
        label: "E",
        data: [0, 0, 0],
        backgroundColor: "#fb6340",
      },
    ],
    labels: ["Area", "Faturamento", "Margem"],
  }
})

const percentCurve = () => {
  const countByProperty = (clients, property, value) =>
    clients.filter((client) => client[property] === value).length;

  const calculatePercentage = (count, total) => (count / total) * 100;

  const areas = ["A", "B", "C", "D", "E"];
  const revenues = ["A", "B", "C", "D", "E"];
  const margins = ["A", "B", "C", "D", "E"];

  const areaCounts = areas.map((area) =>
    countByProperty(clients.value, "see_type_area", area)
  );
  const revenueCounts = revenues.map((revenue) =>
    countByProperty(clients.value, "see_type_revenue", revenue)
  );
  const marginCounts = margins.map((margin) =>
    countByProperty(clients.value, "see_type_margin", margin)
  );

  const areaPercentages = areaCounts.map((count) =>
    calculatePercentage(count, clients.value.length)
  );
  const revenuePercentages = revenueCounts.map((count) =>
    calculatePercentage(count, clients.value.length)
  );
  const marginPercentages = marginCounts.map((count) =>
    calculatePercentage(count, clients.value.length)
  );

  bigBarChart.value.chartData.datasets = bigBarChart.value.chartData.datasets.map((dataset, index) => Object.assign(dataset, {
    data: [
      areaPercentages[index],
      revenuePercentages[index],
      marginPercentages[index],
    ]
  }))
  
  mappedData.value = true
};


const clients = ref([])
const getClients = async () => {
  loading.value = true;

  try {
    const response  = await axios.get("/api/v1/clients")
    clients.value   = response.data.clients

    percentCurve()
  } catch (error) {
    console.error("[getClients]", error);
  } finally {
    loading.value = false;
  }
}

onBeforeMount(() => {
  getClients()
});

</script>
